import AdminDashboard from "./AdminDashboard";
import CompanyStats from "./CompanyStats";
import PipelineStatus from "./PipelineStatus";
import ServiceDeployments from "./ServiceDeployments";
import SiteDeployments from "./SiteDeployments";
import DashboardContent from "components/layout/DashboardContent";
import TopNav from "components/layout/TopNav";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

const PARENT_PATH = "infra";

const TABS = [
  {
    title: "Deployment Pipeline",
    path: "pipeline",
    element: <PipelineStatus />,
  },
  {
    title: "Deployment Status",
    path: "status",
    element: <ServiceDeployments />,
  },
  {
    title: "Site Deployments",
    path: "site-deployments",
    element: <SiteDeployments />,
  },
  {
    title: "Submission Cache",
    path: "submission-cache",
    element: <CompanyStats />,
    isFullWidth: true,
  },
];

const Infra = () => {
  const { pathname } = useLocation();
  const segments = pathname.split("/");
  const tabSegment = segments[segments.indexOf(PARENT_PATH) + 1];
  const activeTab = TABS.find((tab) => tab.path === tabSegment);

  return (
    <AdminDashboard>
      <TopNav tabs={TABS} parentPath={PARENT_PATH} />
      <DashboardContent isFullWidth={Boolean(activeTab?.isFullWidth)}>
        <Routes>
          {TABS.map(({ element, path }) => (
            <Route key={path} path={`${path}/*`} element={element} />
          ))}
          <Route
            path={"*"}
            element={<Navigate to={TABS[0].path} replace={true} />}
          />
        </Routes>
      </DashboardContent>
    </AdminDashboard>
  );
};

export default Infra;
